import { Checkbox, CheckboxChangeEvent, Select } from 'antd';
import { SvgIcon } from '../../../../components/svg-icon/svg-icon';
import './opening-time-period.scss';
import './../../opening-time-page.scss';
import { useMemo } from 'react';
import { Schedule } from '../../../../core/models/schedule';
import { DefaultOptionType } from 'antd/es/select';
import { useTranslation } from 'react-i18next';

type OpeningTimePeriodProps = {
	schedule: Schedule[];
	onChangeSchedule: (schedule: Schedule[]) => void;
};

export const OpeningTimePeriod: React.FC<OpeningTimePeriodProps> = ({ schedule, onChangeSchedule }) => {
	const { t } = useTranslation();
	const minuteStep = 15;

	const timeOptions: DefaultOptionType[] = useMemo(() => {
		const options: DefaultOptionType[] = [];

		for (let hour = 0; hour < 24; hour++) {
			for (let minute = 0; minute < 60; minute += minuteStep) {
				const timeLabel = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
				options.push({ value: timeLabel, label: timeLabel });
			}
		}
		return options;
	}, [t]);

	const handleChangeSelectTime = (weekday: string, value: Date, type: 'START' | 'END') => {
		const updatedSchedule = schedule.map((entry) =>
			entry.weekday === weekday
				? {
						...entry,
						[type === 'START' ? 'startTime' : 'endTime']: value,
					}
				: entry
		);
		onChangeSchedule(updatedSchedule);
	};

	function onChangeEnabledWeekday(e: CheckboxChangeEvent, weekday: string): void {
		const updatedSchedule = schedule.map((entry) =>
			entry.weekday === weekday
				? {
						...entry,
						enabled: e.target.checked,
					}
				: entry
		);

		onChangeSchedule(updatedSchedule);
	}

	return (
		<div className='opening-time-period'>
			{schedule.map(({ weekday, enabled, startTime, endTime }) => (
				<div key={weekday} className='opening-time-period-row'>
					<div className='opening-time-column-title col'>
						<Checkbox checked={enabled} defaultChecked={enabled} onChange={(value) => onChangeEnabledWeekday(value, weekday)} />
						<span>{t(`common.weekDays.${weekday.toLowerCase()}`)}</span>
					</div>
					<div className='col'>
						<Select
							showSearch
							onChange={(value) => handleChangeSelectTime(weekday, value, 'START')}
							prefix={<SvgIcon name='time' size={16} />}
							options={timeOptions}
							value={startTime}
							disabled={!enabled}
						/>
					</div>
					<div className='col'>
						<Select
							showSearch
							onChange={(value) => handleChangeSelectTime(weekday, value, 'END')}
							prefix={<SvgIcon name='time' size={16} />}
							options={timeOptions}
							value={endTime}
							disabled={!enabled}
						/>
					</div>
				</div>
			))}
		</div>
	);
};
